export default "__VITE_ASSET__BcbYI$$O__"